import React from "react";
import "./Home.css";
import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
          alt=""
        />

        <div className="home__row">
          <Product
            id={1234567}
            title="The Kaws Man"
            price={15.99}
            image="https://toyqube.com/cdn/shop/products/Kaws_Astroboy_OG_300x.jpg?v=1597878423"
            rating={4}
          />
          <Product
            id={7654321}
            title="Limited Edition: Black Stallion"
            price={7478.99}
            image="https://www.breyerhorses.com/cdn/shop/products/black-beauty-horse-book-set-model-breyer-545359_2000x.jpg?v=1666319469"
            rating={5}
          />
          <Product
            id={1234568}
            title="Bearbrick"
            price={499.99}
            image="https://i.pinimg.com/originals/b9/26/a7/b926a7a70c031f5a78e4ecbe6e83ab93.jpg"
            rating={5}
          />
        </div>

        <div className="home__row">
          <Product
            id={1234598}
            title="Apple Watch Series 7 GPS, 45mm Midnight Aluminum Case with Midnight Sport Band - Regular"
            price={379.99}
            image="https://i5.walmartimages.com/seo/Apple-Watch-Series-7-GPS-45mm-Midnight-Aluminum-Case-with-Midnight-Sport-Band-Regular_d2cca1d2-a49a-4d21-b640-c50e7dfaf46d.786d7fb757f3937dc064c06bb782855e.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"
            rating={3}
          />
          <Product
            id={1474567}
            title="Marcus Aurelius - Meditations: Adapted for the Contemporary Reader"
            price={17.99}
            image="https://i.pinimg.com/originals/20/92/bb/2092bbaa013a50a1f7e547d52e6c60a6.jpg"
            rating={3}
          />
        </div>

        <div className="home__row">
          <Product
            id={1231967}
            title="Men's Inter Miami CF Lionel Messi adidas Black 2023 La Noche Replica Jersey"
            price={109.99}
            image="https://images.footballfanatics.com/inter-miami-cf/youth-adidas-lionel-messi-black-inter-miami-cf-2023-la-noche-replica-jersey_ss5_p-200282043+pv-1+u-oyvsvavez6wcnphogps8+v-uwug2ihgaa1y0c7ovul8.jpg?_hv=2&w=900"
            rating={5}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
